export const GET_LATEST_NEWS_DATA = ' GET_LATEST_NEWS_DATA';
export const GET_LATEST_NEWS_DATA_SUCCESS = ' GET_LATEST_NEWS_DATA_SUCCESS';
export const GET_LATEST_NEWS_DATA_FAILED = ' GET_LATEST_NEWS_DATA_FAILED';

export function getLatestNews() {
    return {
        type: GET_LATEST_NEWS_DATA,
    };
}
